$(function() {
    $('.checkbox-to-replace').each(function() {
        var current = $(this);
        current.wrap('<label class="checkbox-replace" for="' + current.attr('id') + '"></label>');
        current.after('<div class="checkbox-replace__display"><div class="checkbox-replace__checkbox"></div></div>');

        var wrap = $(this).parent();

        if (current.prop('checked')) {
            wrap.addClass('checkbox-replace--checked');
        }

        if (current.prop('disabled')) {
            wrap.addClass('checkbox-replace--readonly');
        }


        current.on('change', function (e) {
            if (current.prop('checked')) {
                wrap.addClass('checkbox-replace--checked');
            } else {
                wrap.removeClass('checkbox-replace--checked');
            }

            return true;
        });

        $(this).trigger('change');
    });
});
